import { useTranslation } from "react-i18next";
import { Button as ButtonLib } from "@npm_leadtech/qr-ui-components";

import { ListActionButtonProps } from "./types";

export const ListActionButton = ({
  actionButton,
  onActionButtonClick,
  disabled,
}: ListActionButtonProps) => {
  const { t } = useTranslation("feedback");

  const button = actionButton || (
    <ButtonLib
      shape="ghost"
      id="action-button-default"
      data-testId="action-button-default"
      label={t("category_add_category_button")}
      onClick={onActionButtonClick}
      disabled={disabled}
      dataQA="action-button-default"
    />
  );

  return <div className="buttonWrapper action-button">{button}</div>;
};
